export default {
  sidebar: {
    roles: 'Roles',
    roleGroups: 'Role Groups',
    users: 'users',
    userGroups: 'User Groups',
    approvals: 'Approvals',
  },
};
